import { useState } from 'react'
import Link from 'next/link'
import NavLinkButton from '@components/shared/NavLinkButton'
import { DOC_TYPE_INFO } from '../../../../constants/articles/docTypes'
import { categoryLink, dateLink, tagLink } from '@components/blog/utils/postLinks'
import { categoryName } from '@components/blog/utils/post'
import monthText from '@utils/date/monthAsText'
import useT from '@hooks/useTranslation'

import styles from '@components/blog/styles/Sidebar.module.css'

const useSidebarComponents = (sidebar, onMobile, displayTags) => {
    const Categories = allCategoriesSidebar(onMobile)
    const Years = sidebar && yearSidebar(sidebar)
    const Tags = displayTags && sidebar && tagSidebar(sidebar)

    return [Categories, Years, Tags]
}

const MainSidebar = ({ sidebar }) => <>
        { allCategoriesSidebar() }
        { sidebar && yearSidebar(sidebar) }
        { sidebar && tagSidebar(sidebar) }
    </>

function allCategoriesSidebar (onMobile) {
    const [open, setOpen] = useState(!onMobile)
    const toggle = () => setOpen(!open)
    const toggleButton = <div><NavLinkButton color="teal" onClick={toggle} style={{margin:'auto'}}>{useT('Zobacz wszystkie kategorie')}</NavLinkButton></div>
    const shouldDisplay = !onMobile || open
    return <>
        { onMobile && toggleButton }
        { shouldDisplay && sidebarBody(
            "Wszystkie kategorie",
            Object
                .keys(DOC_TYPE_INFO)
                .map(docType => {
                    const input = { docType }
                    const link = categoryLink(input)
                    const name = categoryName(input)
                    return <SidebarLink name={name} link={link} key={link} />
                })
        )}
    </>
}

function yearSidebar ({ dates }) {
    if (noData(dates)) return null
    return sidebarBody(
        "Wiadomości daty",
        dates.map(({ _id: datestring }) => {
            const [year, month] = datestring.split('-')
            const link = dateLink({ created: `${datestring}-1` })
            const name = `${monthText(month - 1)} ${year}`

            return <SidebarLink name={name} link={link} key={link} />
        })
    )
}

function tagSidebar ({ tags }) {
    if (noData(tags)) return null
    return sidebarBody(
        "Dostępne tagi",
        tags.map(tag => {
            const link = tagLink(tag)
            const name = tag
            return <SidebarLink name={name} link={link} key={link} inline />
        }),
        true,
    )
}

function sidebarBody (title = '', sidebarLinks = [], inline = false) {
    return (
        <aside className={styles.sidebar}>
            <h3>{ useT(title) }</h3>
            <ul className={inline
                ? styles.ul
                : undefined}>

                {sidebarLinks}
            </ul>
        </aside>
    )
}

function SidebarLink ({ link = '', name = '', inline = false }) {
    return link != null
        ? <li className={inline
            ? styles.li
            : undefined}>

                <Link href={link}>
                    <a>
                        { name }
                    </a>
                </Link>
          </li>
        : null
}

function noData (array) {
    const isValid = Array.isArray(array) && array.length > 0
    return !isValid
}

export default MainSidebar
export {
    useSidebarComponents,
}